import { Component } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CmsSidebarComponent } from '../common/cms-sidebar/cms-sidebar.component';

@Component({
  selector: 'app-website-cmslayout',
  standalone: true,
  imports: [RouterOutlet, CommonModule, CmsSidebarComponent, RouterLink],
  templateUrl: './website-cmslayout.component.html',
  styleUrl: './website-cmslayout.component.scss',
})
export class WebsiteCMSlayoutComponent {
  isFullNav: any;
  constructor(private router: Router) {}
  logout() {
    sessionStorage.clear();
    this.router.navigate(['/auth']);
  }
}
